const API_VERSIONS = {
  V1: "v1",
  V2: "v2",
};

export const DASHBOARD_ROUTES = {
  GET: {
    DASHBOARD_MODULE_CONFIGURATION: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/modules`,
  },
  POST: {},
  PUT: {
    DASHBOARD_MODULE_CONFIGURATION: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/modules`,
  },
  DELETE: {},
};
